module.exports = __webpack_public_path__ + "img/4.e7c98ea3.webp";